import * as yup from 'yup';

export const UpdateLogoComponentSchema = yup.object({
  logo: yup.mixed(),
});

export interface IUpdateLogoComponent {
  logo: Buffer;
}
